import { filterEventHandler } from 'poly-eshop4/eshop/ui/js/itemlist';

$(document).on(
  'change changed.zf.slider',
  '[data-itemlist-filter] input[type=radio]',
  window.Foundation.util.debounce(filterEventHandler, 0), // prevent double execution when clicking the checkbox
);
